export enum BandTypeEnum {
	RED = 'RED',
	GREEN = 'GREEN',
	BLUE = 'BLUE',
	NIR = 'NIR',
}
